import { AnalyticsMediaKit, Button, ChartHorizontalBar, LogService, Modal } from '@hub/shared'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import './modal-statistics.component.scoped.scss'
import './modal-statistics.component.scss'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  analytics?: AnalyticsMediaKit
  open?: boolean
  onOpenChange?: (open: boolean) => any
}

export default ({ analytics, onOpenChange, open = false }: Props) => {
  const logService = useMemo(() => new LogService(), [])
  const [t] = useTranslation('modalStatistics')
  logService.init('Modal Statistics')

  const handleOnClose = () => {
    if (onOpenChange && typeof onOpenChange === 'function') {
      onOpenChange(false)
    }
  }

  return (
    <Modal
      open={open}
      onCloseChange={() => handleOnClose()}
      className="modal-statistics"
      footer={
        <div className="modal-statistics-footer">
          <Button onClick={() => handleOnClose()} className="modal-statistics-footer-button">
            {t('close')}
          </Button>
        </div>
      }
      header={<h5 className="logo-instagram mb-0">{t('title')}</h5>}
    >
      <div className="banner-views-midia-kit display-flex align-items-center justify-content-center">
        <span>
          <p>{t('textTotalViews')}</p>
          <p className="big-number">{analytics?.totalClicks}</p>
          <p>{t('times')}</p>
        </span>
      </div>
      <div className="display-flex justify-content-space-between my-3">
        <span>{t('textLabelViews30Days')}</span>
      </div>
      <div>
        {analytics?.chart?.clicks?.labels?.length ? <ChartHorizontalBar dataset={analytics?.chart?.clicks}></ChartHorizontalBar> : null}
      </div>
    </Modal>
  )
}
